// src/components/Navbar.js — VERSÃO FINAL 100% FUNCIONAL
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Brain, LogOut } from 'lucide-react';

const Navbar = () => {
  const { user, logout } = useAuth();

  // Pega o username do usuário logado (se existir)
  const username = user?.profileData?.username;

  // ✅ ADICIONADO: Mensagem quando não logado tenta acessar perfil
  const handleProfileClick = (e) => {
    if (!user) {
      e.preventDefault();
      alert('Fazer login para editar perfil');
      return false;
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white z-50 border-b-2 border-violet-500 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
        {/* LOGO - Design atualizado */}
        <Link to="/" className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gradient-to-r from-violet-600 to-green-500 rounded-lg flex items-center justify-center">
            <Brain className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-black">Plexo Natural</h1>
            <p className="text-xs text-gray-600">Proof of Life & Existence</p>
          </div>
        </Link>

        {/* MENU - Todos os links acessíveis sem login */}
        <div className="flex items-center gap-6 text-sm">
          <Link to="/" className="text-black hover:text-violet-600 transition font-medium">
            Home
          </Link>

          {/* ✅ PRESERVADO: Lógica de perfil dinâmico */}
          {/* ✅ ADICIONADO: Mensagem quando não logado */}
          {username ? (
            <Link
              to={`/${username}`}
              className="text-violet-600 font-bold hover:text-violet-700 transition"
            >
              Profile
            </Link>
          ) : (
            <Link
              to="/profile"
              onClick={handleProfileClick}
              className="text-black hover:text-violet-600 transition font-medium"
            >
              Perfil
            </Link>
          )}

          <Link to="/performance-test" className="text-violet-600 font-bold hover:text-violet-700 transition">
            PerformanceArtTest
          </Link>
          <Link to="/live" className="text-black hover:text-violet-600 transition font-medium">
            ProofOfLife
          </Link>
          <Link to="/existence-plexo" className="text-violet-600 font-bold hover:text-violet-700 transition">
            ProofOfExistence
          </Link>
          <Link to="/decoder" className="text-black hover:text-violet-600 transition font-medium">
            ProofDecoder
          </Link>
          <Link to="/about" className="text-black hover:text-violet-600 transition font-medium">
            About
          </Link>
        </div>

        {/* ✅ PRESERVADO: Lógica de user/login */}
        <div className="flex items-center gap-4">
          {user ? (
            <div className="flex items-center gap-3">
              <span className="text-xs text-gray-600">
                Olá, {user.profileData?.name?.split(' ')[0] || 'Usuário'}
              </span>
              <button
                onClick={logout}
                className="text-black hover:text-red-600 transition flex items-center gap-1"
              >
                <LogOut className="w-4 h-4" />
                <span className="text-xs">Sair</span>
              </button>
            </div>
          ) : (
            <Link
              to="/"
              className="bg-gradient-to-r from-violet-600 to-green-500 text-white px-4 py-2 rounded-lg text-sm font-bold hover:from-violet-700 hover:to-green-600 transition shadow-sm"
            >
              Entrar
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
